var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTymeplusPayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_19971_59977)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3,
    width: 62,
    height: 62,
    rx: 31,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 16,
    width: 35.5449,
    height: 35.5449,
    rx: 4.90275,
    fill: "#2D53DA"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19971_59977)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.167 30.1568C46.072 27.8688 45.7656 26.4661 44.7781 25.4785C43.3466 24.0469 41.0422 24.0469 36.434 24.0469H32.7681C28.1596 24.0469 25.8555 24.0469 24.4238 25.4785C22.9922 26.9101 22.9922 29.2143 22.9922 33.8227C22.9922 38.431 22.9922 40.7353 24.4238 42.1668C25.8555 43.5985 28.1596 43.5985 32.7681 43.5985H36.434C41.0422 43.5985 43.3466 43.5985 44.7781 42.1668C45.7656 41.1794 46.072 39.7765 46.167 37.4886",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.167 30.1568C46.072 27.8688 45.7656 26.4661 44.7781 25.4785C43.3466 24.0469 41.0422 24.0469 36.434 24.0469H32.7681C28.1596 24.0469 25.8555 24.0469 24.4238 25.4785C22.9922 26.9101 22.9922 29.2143 22.9922 33.8227C22.9922 38.431 22.9922 40.7353 24.4238 42.1668C25.8555 43.5985 28.1596 43.5985 32.7681 43.5985H36.434C41.0422 43.5985 43.3466 43.5985 44.7781 42.1668C45.7656 41.1794 46.072 39.7765 46.167 37.4886",
    stroke: "white",
    strokeWidth: 0.712407
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0071 30.1602H42.8268C40.6464 30.1602 38.8789 31.8014 38.8789 33.8261C38.8789 35.8508 40.6464 37.492 42.8268 37.492H46.0071C46.109 37.492 46.1598 37.492 46.2029 37.4894C46.8618 37.4493 47.3867 36.962 47.4299 36.3499C47.4327 36.31 47.4327 36.2627 47.4327 36.1682V31.484C47.4327 31.3894 47.4327 31.3422 47.4299 31.3022C47.3867 30.6903 46.8618 30.2029 46.2029 30.1628C46.1598 30.1602 46.109 30.1602 46.0071 30.1602Z",
    fill: "#FF0016"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3923 33.941L25.7697 27.4309L32.9134 33.9751L26.5949 40.8724L28.3923 33.941Z",
    fill: "#2D53DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5332 33.8242H42.5447",
    stroke: "white",
    strokeWidth: 1.49606,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_19971_59977",
    x: 0,
    y: 0,
    width: 70,
    height: 70,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_19971_59977"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_19971_59977",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19971_59977"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.191,
    height: 22.4494,
    fill: "white",
    transform: "translate(21.6777 22.5469)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTymeplusPayIcon);
export default __webpack_public_path__ + "static/media/TymeplusPayIcon.8af1d23cc56b8eaabd5699a3e6a423b4.svg";
export { ForwardRef as ReactComponent };